"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoveOutStatus = void 0;
var MoveOutStatus;
(function (MoveOutStatus) {
    MoveOutStatus["MOVEOUTSTARTED"] = "MOVEOUTSTARTED";
    MoveOutStatus["WAITFORMOVEOUT"] = "WAITFORMOVEOUT";
    MoveOutStatus["MOVEOUTFINALIZED"] = "MOVEOUTFINALIZED";
    MoveOutStatus["MOVEOUTCANCELLED"] = "MOVEOUTCANCELLED";
    MoveOutStatus["MOVEOUTABORTED"] = "MOVEOUTABORTED";
    MoveOutStatus["WAITFORMOVEOUTDATA"] = "WAITFORMOVEOUTDATA";
    MoveOutStatus["WAITFORMOVEOUTDATE"] = "WAITFORMOVEOUTDATE";
    MoveOutStatus["WAITFORMETERREADINGSMOVEOUT"] = "WAITFORMETERREADINGSMOVEOUT";
    MoveOutStatus["MOVEOUTSTARTEDFORENDCONTRACT"] = "MOVEOUTSTARTEDFORENDCONTRACT";
    MoveOutStatus["WAITFORMOVEOUTENDCONTRACT"] = "WAITFORMOVEOUTENDCONTRACT";
})(MoveOutStatus = exports.MoveOutStatus || (exports.MoveOutStatus = {}));
